import React, {useEffect} from 'react';
import classnames from 'classnames';
import {PDFDownloadLink} from '@react-pdf/renderer';

import PrintResumeDocument from 'src/components/Resume/document';
import {sharePdfForAnyPlatform} from 'src/utils/pdf-utils';
import PlatformService from 'src/services/PlatformService';
import {Student} from 'src/types/store';

import styles from './list-item.module.scss';

interface Props {
  printInfo: {
    student: Student;
    blackAndWhite?: boolean;
  };
  children: string;
  filename: string;
  eventName: string;
  onClick?: () => void;
}

const PdfLink = ({printInfo, children, filename, eventName, onClick}: Props) => {
  useEffect(() => {
    if (!PlatformService.isNativeApp()) {
      const element = document.querySelector(`.${styles.listItem}.pdf-link`);

      if (eventName && element) {
        element.setAttribute('data-segment-track', 'link');
        element.setAttribute('data-link-name', eventName);
      }
    }
  }, [eventName]);

  const printResume = async () => {
    try {
      if (onClick) {
        onClick();
      }

      await sharePdfForAnyPlatform(
        <PrintResumeDocument {...printInfo} />,
        filename,
        children,
        `My ${children} from Raise.me`
      );
    } catch (error) {
      console.error('Native PDF share failed:', error);
    }
  };

  if (PlatformService.isNativeApp()) {
    return (
      <li>
        <button
          className={classnames('pdf-link', styles.listItem)}
          onClick={printResume}
          type="button"
        >
          {children}
        </button>
      </li>
    );
  }

  return (
    <li>
      <span onClick={onClick}>
        <PDFDownloadLink
          className={classnames('pdf-link', styles.listItem)}
          document={<PrintResumeDocument {...printInfo} />}
          fileName={filename}
        >
          {children}
        </PDFDownloadLink>
      </span>
    </li>
  );
};

export default PdfLink;
